const ADMIN = "/admin"
const UNAUTHORIZED = `${ADMIN}/unauthorized`
const ADMIN_TODOS = `${ADMIN}/to-dos`
const ADMIN_GUESTS = `${ADMIN}/guests`
const ADMIN_GUESTS_GUEST = `${ADMIN}/guests/:guestId`
const ADMIN_STORE = `${ADMIN}/store`
const ADMIN_STORE_POS = `${ADMIN_STORE}/pos`
const ADMIN_STORE_HISTORY = `${ADMIN_STORE}/history`
const ADMIN_SETTINGS = `${ADMIN}/settings`
const ADMIN_SETTINGS_CAMP_INFO = `${ADMIN_SETTINGS}/camp-info`
const ADMIN_SETTINGS_INVOICES = `${ADMIN_SETTINGS}/invoices`
const ADMIN_SETTINGS_PRODUCTS = `${ADMIN_SETTINGS}/products`
const ADMIN_SETTINGS_COUPONS = `${ADMIN_SETTINGS}/coupons`
const ADMIN_SETTINGS_AUTOMATED_MESSAGES = `${ADMIN_SETTINGS}/automated-messages`
const ADMIN_SETTINGS_RULES_TERMS = `${ADMIN_SETTINGS}/rules-terms`
const ADMIN_SETTINGS_PRICES = `${ADMIN_SETTINGS}/prices`
const ADMIN_SETTINGS_USERS = `${ADMIN_SETTINGS}/users`
const ADMIN_SETTINGS_SITES = `${ADMIN_SETTINGS}/sites`
const ADMIN_SETTINGS_RESERVATION_IMPORT = `${ADMIN_SETTINGS}/reservation-import`
const ADMIN_SETTINGS_CAMPER_IMPORT = `${ADMIN_SETTINGS}/camper-import`

export const ROUTER_PATHS = {
  UNAUTHORIZED,
  ADMIN,
  ADMIN_TODOS,
  ADMIN_GUESTS,
  ADMIN_GUESTS_GUEST,
  ADMIN_STORE,
  ADMIN_STORE_POS,
  ADMIN_STORE_HISTORY,
  ADMIN_SETTINGS,
  ADMIN_SETTINGS_CAMP_INFO,
  ADMIN_SETTINGS_INVOICES,
  ADMIN_SETTINGS_PRODUCTS,
  ADMIN_SETTINGS_COUPONS,
  ADMIN_SETTINGS_AUTOMATED_MESSAGES,
  ADMIN_SETTINGS_RULES_TERMS,
  ADMIN_SETTINGS_PRICES,
  ADMIN_SETTINGS_USERS,
  ADMIN_SETTINGS_SITES,
  ADMIN_SETTINGS_RESERVATION_IMPORT,
  ADMIN_SETTINGS_CAMPER_IMPORT,
}
